module.exports = __webpack_public_path__ + "fonts/iconfont.ba2bdb90.woff2";